import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import EditIcon from '@mui/icons-material/Edit'
import SimulationIcon from '@mui/icons-material/AutoGraph'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { EditProps } from '../shared/EditProps'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/useAuth'

export default function EditSimulation({ disabled, schema, value, setData }: EditProps) {
  const navigate = useNavigate()
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

  if (!value) return null

  const copy = { ...value }

  // convert dates to ISO string
  const convert = {
    start_time: new Date(copy.start_time).toISOString(),
    end_time: new Date(copy.end_time).toISOString(),
  }

  Object.assign(copy, convert)

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Edit Simulation`}
      icon={<SimulationIcon />}
      iconButton={<EditIcon />}
      content={
        <Form
          onSubmit={async (e) => {
            // convert ISO strings to required format for backend
            e.formData.start_time = format(new Date(e.formData.start_time), 'yyyy-MM-dd HH:mm')
            e.formData.end_time = format(new Date(e.formData.end_time), 'yyyy-MM-dd HH:mm')
            try {
              const res = await axios.put(
                `${process.env.REACT_APP_API}/${copy.simulation_name}`,
                JSON.stringify(e.formData),
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrf,
                  },
                  withCredentials: true,
                }
              )
              // if simulation name was changed in detail page, redirect to new url
              if (copy.simulation_name !== e.formData.simulation_name)
                navigate('/' + e.formData.simulation_name + '?tab=config')

              setData(res.data)
              setOpen(false)
            } catch (err) {
              console.log('err:', err)
            }
          }}
          validator={validator}
          schema={schema as JSONSchema7}
          formData={copy}
        />
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
